import { createContext, useContext } from 'react';
const defaultActionContext = {
  onButtonClick: () => {},
  getActionState: () => 'idle',
  isCardDisabled: false,
  allRequiredBindingsFilled: true,
  isReadOnly: false
};
const ActionContext = /*#__PURE__*/createContext(defaultActionContext);
export const ActionContextProvider = ActionContext.Provider;
export function useActionContext() {
  return useContext(ActionContext);
}